import React from 'react';
import classNames from 'classnames';
import InputNumber from '../../../../../../../shared/design-system/components/input-number';

const InboxPlacementDailySendingLimitInput = ({
  t,
  sendingLimit,
  changeSendingLimit,
  zeroLimitError,
  isBulkUpdatingEmailAccounts,
  maxLimit,
}) => {
  const onKeyPress = (e) => {
    if (e.key === '.' || e.key === '+' || e.key === '-' || e.key === 'e') {
      e.preventDefault();
    }
  };

  const rowClasses = classNames([
    'inbox-placement-row',
    {
      'bulk-update-email-accounts-row': isBulkUpdatingEmailAccounts,
      'align-items-center': !isBulkUpdatingEmailAccounts,
      'row': isBulkUpdatingEmailAccounts,
    },
  ]);

  return (
    <div className={rowClasses}>
      <div className="col-md-8">
        <p className="total-number-title mb-1">
          Total inbox placement test emails per day
        </p>
        {!isBulkUpdatingEmailAccounts && (
          <p className="total-number-caption m-0">
            Maximum number of test emails that could be sent via this email
            account per day
          </p>
        )}
      </div>
      <div className="sending-limit-input">
        <InputNumber
          size={InputNumber.Size.Medium}
          min={0}
          max={maxLimit}
          value={sendingLimit}
          onChange={changeSendingLimit}
          variant={zeroLimitError && InputNumber.Variant.Error}
          onKeyPress={onKeyPress}
        />
      </div>
    </div>
  );
};

export default InboxPlacementDailySendingLimitInput;
